﻿import { defineComponent } from 'vue';

import { useBookingStore } from '../../../store/bookingstore';

import passenger_details from "../../base/passenger_details.vue"
import tour_details from "../../base/2_tour_details/tour_details.vue"
import basket_item from "./basket_item.vue"

import itinerary from "./itinerary.vue";

import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group"
import { age_cat } from "../../../objects/v1_3/web_engine/age_cat"
import { v1_2_get_booking_trip } from "../../../objects/v1_2/v1_2_get_booking/v1_2_get_booking_trip"
import { Product } from '../../../services/product';
import { Booking } from '../../../services/booking';
import { Web_Engine } from '../../../services/web_engine';

import { Date_Service } from '../../../../system/services/date_service';
import { Currency_Service } from '../../../../system/services/currency';

const Book: Booking = new Booking();
const Prod: Product = new Product();
const Web_Engines: Web_Engine = new Web_Engine();

const Date_Services: Date_Service = new Date_Service();
const Currency_Services: Currency_Service = new Currency_Service();

import { product_detail } from '../../../objects/v1_3/product/product/product_detail';
import { booking_info } from '../../../objects/v1_2/Booking_Details/booking_info';
import { trip } from '../../../objects/v1_2/Booking/Trip';
import { request_payment_initialise_internal } from 'modules/tms/booking_engine/objects/v1_3/payment/initialise/request_payment_initialise_internal';
import payment from '../../consumer/payment';
import { request_payment_initialise_internal } from 'modules/tms/booking_engine/objects/v1_3/payment/initialise/request_payment_initialise_internal';

class GooglePassengerDetail {
    public age_cat: string = "";
    public count: number = 0;
    public price: number = 0;
}

export default defineComponent({
    name: "basket",
    components: {
        passenger_details,
        itinerary,
        tour_details,
        basket_item
    },
    props: {
        // cart page: show each tour's add-ons (added, and the "addons" slot for the available ones) as a subpanel under
        // that tour, instead of one list after all the tours
        group_addons: { type: Boolean, default: false }
    },
    data() {
        return {
            isHidden: true as boolean,
            isHidden_Edit_Tour: true as boolean,
            // the basket trip Edit tour changes (its index in get_Basket.trips), passed to tour_details
            edit_trip_index: 0 as number,
            tour_id: "" as string,
            age_cat: new age_cat() as age_cat,
            deletedTours: [] as string[],
            // add-ons being removed (tour_id → their tour), see Remove_Trip
            removing_add_ons: {} as Record<string, string>
        }
    },
    setup() {
        const bookingStore = useBookingStore();

        return {
            bookingStore
        }
    },
    methods: {
        async download_passenger() {
            const web_engine = new Web_Engine();
            this.age_cat = await web_engine.Get_Passengers();
            this.age_cat.categories = this.age_cat.categories.sort((first, second): number => {
                return 0 - (first.name > second.name ? -1 : 1)
            });
        },
        get_Trips() {
            // get_Booking is null while a new quote is calculated (Book.Setup_Booking), e.g. when the passengers change in Edit tour
            let all_trips : v1_2_get_booking_trip[] = this.$store.getters.get_Booking?.trips ?? [];
            let show_agent_bookings : boolean = this.isAgent_Login();

            let payment_session_old : request_payment_initialise_internal = this.$store.getters.get_Payment_Session;
            let is_nett_sale: boolean = payment_session_old?.payment_initialise?.nett_sale ?? false;

            // Only show the trips being paid for: filter on the payments' tour_ids, unless there are no payments
            // or any payment has no tour_id (it then covers the whole booking), in which case show every trip.
            let payments = payment_session_old?.payment_initialise?.payments ?? [];
            let payment_tour_ids: string[] = payments.map(payment => payment.tour_id ?? "");

            if (payment_tour_ids.length > 0 && !payment_tour_ids.includes("")) {
                all_trips = all_trips.filter(t => payment_tour_ids.includes(t.tour_id ?? ""));
            }

            if (show_agent_bookings === false && is_nett_sale === false)
                return all_trips.filter(t => (t.affiliate == null || t.affiliate == ""));
            else
                return all_trips;
        },
        add_on_tour(trip: booking_info): boolean {
            return Book.Add_On(trip, this.$store) || (trip?.tour_id ?? "") in this.removing_add_ons;
        },
        // the tour an add-on belongs to, also while it's being removed (falls back to the first tour, as before)
        add_on_parent_id(trip: booking_info): string {
            return this.removing_add_ons[trip?.tour_id ?? ""] || Book.Add_On_Parent(trip, this.$store);
        },
        add_on_parent(trip: booking_info): string {
            return this.add_on_parent_id(trip) || (this.$store.getters.get_Basket?.trips[0]?.tour_id ?? "");
        },
        // the rows to show, in order. With group_addons: each tour, then its added add-ons (nested), then an "addons" row
        // for the slot (the tour's available add-ons). Add-ons whose tour isn't in the list stay as their own rows.
        Display_Rows(): { key: string, type: 'trip' | 'addons', trip: any, nested: boolean }[] {
            const trips: any[] = this.get_Trips() ?? [];
            if (!this.group_addons) {
                return trips.map(t => ({ key: 'trip:' + t.tour_id, type: 'trip' as const, trip: t, nested: false }));
            }

            const listed = new Set(trips.filter(t => !this.add_on_tour(t)).map(t => t.tour_id));
            const rows: { key: string, type: 'trip' | 'addons', trip: any, nested: boolean }[] = [];

            trips.forEach(t => {
                const is_add_on = this.add_on_tour(t);
                const parent = is_add_on ? this.add_on_parent_id(t) : "";
                if (is_add_on && listed.has(parent)) {
                    return;     // shown under its tour below
                }

                rows.push({ key: 'trip:' + t.tour_id, type: 'trip', trip: t, nested: false });
                if (is_add_on) {
                    return;
                }

                trips.filter(a => this.add_on_tour(a) && this.add_on_parent_id(a) == t.tour_id)
                    .forEach(a => rows.push({ key: 'addon:' + t.tour_id + ':' + a.tour_id, type: 'trip', trip: a, nested: true }));

                // the available add-ons, only where the page provides them (the cart; not checkout)
                const basket_trip = this.$store.getters.get_Basket?.trips?.find((b: any) => b.tour_id == t.tour_id);
                if (basket_trip && this.$slots.addons) {
                    rows.push({ key: 'addons:' + t.tour_id, type: 'addons', trip: basket_trip, nested: true });
                }
            });

            return rows;
        },
        get_Tour_description(tour_id: string): string {
            let tour_details = this.get_Tour_Details(tour_id,);
           let description = Prod.get_description_headline(tour_details);
            return  Prod.get_description_headline(tour_details);
        },
        get_Tour_Details(tour_id: string): product_detail {
            return Prod.Get_Details_Sync(tour_id, this.$store);
        },
        duration(tour_id: string): string {
            return Prod.product_duration(Prod.Get_Details_Sync(tour_id, this.$store));
        },
        durationInDays(tour_id: string): string {
            return Prod.product_durationInDays(Prod.Get_Details_Sync(tour_id, this.$store));
        },
        trip_starts(departure_date: string, tour_id: string) {
            return Prod.trip_starts(departure_date, Prod.Get_Details_Sync(tour_id, this.$store));
        },
        trip_starts_date(departure_date: string) {
             return Date_Services.full_date(departure_date);
        },
        // an add-on's date for its "Add-on for …" pill; '' when there's no valid date (the pill then just says "Add-on")
        add_on_date(trip: any): string {
            if (!trip?.departure_date) return "";
            const date = this.trip_starts_date(trip.departure_date);
            return this.valid_Times(date) ? date : "";
        },
        trip_ends(departure_date: string, tour_id: string) {
            return Prod.trip_ends(departure_date, Prod.Get_Details_Sync(tour_id, this.$store));
        },
        trip_ends_date(departure_date: string, tour_id: string) {
            let tour_details = Prod.Get_Details_Sync(tour_id, this.$store);
            let rounded_days = Prod.getRoundedDays(tour_details.operational_information?.duration);    
            return Date_Services.full_date(Date_Services.getReturnDate(departure_date, (rounded_days == 0) ? 1 : rounded_days));
        },
        trip_checkintime(tour_id: string) {
            return Prod.trip_checkintime(Prod.Get_Details_Sync(tour_id, this.$store));
        },
        start_location(tour_id: string) {
            const product_detail : product_detail= Prod.Get_Details_Sync(tour_id, this.$store);
            const start = Prod.product_start_location(product_detail);
            if (start == undefined || start == ", ")
                return null;
            else 
                return start;
        },
        end_location(tour_id: string) {
            return Prod.product_end_location(Prod.Get_Details_Sync(tour_id, this.$store));
        },
        get_Image(tour_id: string, width: number, height: number) {
            let image =  Prod.get_image(Prod.Get_Details_Sync(tour_id, this.$store), width, height);
            if(image.includes('undefined') || image.includes('NaN'))
            {
                image = this.get_default_product_image();
            }            
            return image;
        },
        get_default_product_image(): string {
            return import.meta.env.VITE_DEFAULT_PRODUCT_IMAGE;
        },
        imageAltText(tour_id: string): string {
            return Prod.Get_Details_Sync(tour_id, this.$store).marketing_information?.media[0]?.assets[0]?.name ?? "Image of " + Prod.Get_Details_Sync(tour_id, this.$store).name;
        },
        get_price(trip: booking_info): string {
            return Currency_Services.Format_Currency(Book.get_price(trip), this.$store.getters.get_Currency);
        },
        get_Currency(): string {
            return this.$store.getters.get_Currency?.currency_info?.iso_currency_code;
        },
        valid_Times(timeString: string)
        {
            if(timeString.includes('NaN') || timeString.includes('undefined'))
            {
                return false;
            }
            else
            {
                return true;
            }
        },
        async Remove_Trip(tour_id: string) {
            // an add-on leaves the basket straight away, but stays in the quote until it's re-quoted: remember its tour
            // so it keeps showing (as "Removing…") under that tour instead of briefly as a main tour
            const parent = Book.Add_On_Parent({ tour_id } as any, this.$store);
            if (parent != "") {
                this.removing_add_ons = { ...this.removing_add_ons, [tour_id]: parent };
            }

            this.deletedTours.push(tour_id);
            this.$store.commit("Remove_Product", { Tour_ID: tour_id });
            this.gtag_remove_from_cart(tour_id);

            try {
                if (Web_Engines.getSession_ID(this.$route.path) + "" != "") {
                    this.$store.commit("Setup_Booking", { Booking_Details: await Book.Quote_Booking(this.$store) });
                    this.$router.push({ path: "/" + Web_Engines.get_Booking_URL(this.$route.path) + "/cart/" + Web_Engines.getSession_ID(this.$route.path), hash: "#add_on_" + tour_id });
                }
                else {
                    if (this.$store.getters.get_Basket?.trips[0]?.tour_id == "" || this.$store.getters.get_Basket.trips.length == 0) {
                        this.$router.push("/");
                    } else {
                        this.$store.commit("Setup_Booking", { Booking_Details: await Book.Quote_Booking(this.$store) });
                        this.$router.push({ path: "/cart", hash: "#add_on_" + tour_id });
                    }
                }
            } finally {
                // done: the new quote no longer has it. Also clears "Removing…" for when the same add-on is added again.
                this.deletedTours = this.deletedTours.filter(id => id != tour_id);
                const { [tour_id]: _done, ...still_removing } = this.removing_add_ons;
                this.removing_add_ons = still_removing;
            }
        },
        gtag_get_item(index: number, paxType: string, paxCount: number, paxPrice: number, trip) {

           
            let lengthCategory = "1 Day Tours";
            if(parseInt(Prod.product_durationInDays(Prod.Get_Details_Sync(this.tour_id, this.$store)).replace(" days", "").replace(" day", "")) > 1){
                lengthCategory = "3-8 Day Tours";
            }

            let product_details = Prod.Get_Details_Sync(trip.tour_id, this.$store);

            var item = {
                item_id: trip.tour_id,
                item_name: product_details.name,
                affiliation: import.meta.env.VITE_DEFAULT_TAB_TEXT + " Booking Engine",
                coupon: trip?.promo_code,
                index: index,
                item_brand: import.meta.env.VITE_DEFAULT_TAB_TEXT,
                item_category: Prod.product_durationInDays(product_details),
                item_category2: lengthCategory,
                item_category3: Prod.product_start_location(product_details),
                item_category4: paxType,
                item_list_name: lengthCategory,
                price: paxPrice,
                quantity: paxCount
            };

            return item;
        },
        
        gtag_remove_from_cart(tour_id: string) {

            var allItems: [] = [];
            var index = 0;
            var totalAmount = 0;
            var GooglePassengerDetails: GooglePassengerDetail[] = [];



            var trip = this.$store.getters.get_Booking?.trips[0];

            this.$store.getters.get_Booking?.trips.forEach(currenttrip => {
                if(currenttrip.tour_id == tour_id){
                    trip = currenttrip;
                }
            });
            

            trip.passengers.forEach(pax => {
                let passengerAge = Book.get_Passenger_Age_Cat(pax.passenger_identifier, this.$store.getters.get_Booking);
                totalAmount += pax.price;

                if(GooglePassengerDetails.findIndex(f => f.age_cat == passengerAge) == -1){
                    GooglePassengerDetails.push({age_cat: passengerAge, count: 1, price: pax.price});
                }
                else{
                    let index_location = GooglePassengerDetails.findIndex(f => f.age_cat == passengerAge);
                    GooglePassengerDetails[index_location].count++;
                    GooglePassengerDetails[index_location].price = pax.price;
                }

            });

            GooglePassengerDetails.forEach(pax => {
                allItems.push(this.gtag_get_item(index, pax.age_cat, pax.count, pax.price, trip));
                index++;
            });


            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            window.dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    currency: this.$store.getters.get_Currency,
                    value: totalAmount,
                    items: allItems
                }
            });
        },
        is_non_listed_tour(tour_id: string): boolean {
            let tour = this.get_Tour_Details(tour_id)
            if (tour.name == '' || tour.name == null) {
                return true;
            }
            return true;
        },
        deletedTour(tour_id: string): boolean {
            return this.deletedTours.includes(tour_id);
        },
        tour_selected(tour_id: string) {
            this.tour_id = tour_id;
            this.isHidden = false;

            this.$refs.itinerary.download_product(tour_id);
        },
        // Edit the tour's own basket trip: without the index tour_details changed the first trip, so editing the second
        // tour replaced the first one with it. Wait for the index to reach tour_details before it loads (and selects) the tour.
        async tour_edit(tour_id: string) {
            this.tour_id = tour_id;
            const index = (this.$store.getters.get_Basket?.trips ?? []).findIndex((Trip: any) => Trip.tour_id == tour_id);
            this.edit_trip_index = index >= 0 ? index : 0;
            await this.$nextTick();

            this.$refs.tour_details.download_product(tour_id);

            this.isHidden_Edit_Tour = false;
        },
        Add_To_Cart() {
            this.isHidden_Edit_Tour = true;
        },
        getPassenger_Details(tour_id: string): string {
            return Book.Passenger_Details(false, this.age_cat, tour_id, this.$store.getters.get_Booking);
        },
        item_total(trip: booking_info): string {
            if (this.$store.getters.get_Booking?.passengers?.length == null || this.$store.getters.get_Booking?.passengers?.length == 0) {
                return "";
            }
            return "x" + this.$store.getters.get_Booking?.passengers?.length;
        },
        passenger_total(tour_id: string): string {
            if (this.$store.getters.get_Booking?.passengers?.length == null || this.$store.getters.get_Booking?.passengers?.length == 0) {
                return "";
            }

            if (this.$store.getters.get_Booking?.passengers?.length == 1) {
                return "1 passenger";
            }

            return this.$store.getters.get_Booking?.passengers?.length + " passengers";
        },
        isMobile(): boolean{
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        getProductName(trip: booking_info): string {
            let product_details = Prod.Get_Details_Sync(trip.tour_id, this.$store);
            if (product_details.name != null && product_details.name != "")
            {  
                return this.FormatProductName(product_details.name);
            }
            else
            {  
                return this.FormatProductName(trip.tour_name);
            }
            
        },
        isAAT(): boolean {
            if (import.meta.env.VITE_DEFAULT_PARENT == "AAT") {
                return true;
            }
            return false;
        },
        FormatProductName(product_name: string): string {
            return product_name.split(' (')[0];
        },
        FormatDescription(description: string): string {
            if(description?.length > 200)
            {
                return description.substring(0, 180) + "...";
            }
            return description;
        },
        zeroPriceCheck(trip: booking_info): boolean {
            if (import.meta.env.VITE_DEFAULT_SEARCH_DATE_RANGE == "true") {
                return true;
            }
            else
            {
                return Book.get_price(trip) != 0;
            }
        },
        isAgent_Login(): boolean {
            let payment_app_id = this.bookingStore.payment_app_id;
            if (payment_app_id != null && payment_app_id != "" && payment_app_id != import.meta.env.VITE_APP_ID) {
                return true;
            }

            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        async download_product(tour_id: string): Promise<void> {
            await Prod.Get_Details(tour_id, this.$store);
        },
        paymentLinkProductDownload() {
            if(this.isPaymentLink())
            {
                (this.$store.getters.get_Booking?.trips ?? []).forEach(trip => {
                    this.download_product(trip.tour_id);
                });
            }
        },
        isGiftCard(trip: booking_info): boolean {
            if(trip.tour_name.toLowerCase().includes("gift")) return true;
            return false;
        },
        isPaymentLink(): boolean {
            return window.location.href.toLowerCase().includes('paylink') || window.location.href.toLowerCase().includes('linkpay') || window.location.href.toLowerCase().includes('confirmation');
        },
        isBookedTour(trip: booking_info): boolean {
            if (trip?.booking_identifier == undefined)
            {
                return false;
            }

            return trip?.booking_identifier + "" != "";
        }    
    },
    mounted() {
        this.download_passenger();
        this.paymentLinkProductDownload();
    }
})